import React from 'react';
import 'Lessons/angularModule';
import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const StreamDashboardDirective = angularDirectiveToReact('streamDashboard', {
    streamId: '<',
});

export const StreamDashboardComponent: React.FC = () => {
    const [key, params] = useAngularToReactRoute<{
        streamId: string;
    }>();

    return <StreamDashboardDirective key={key} {...params} />;
};
